import React from 'react';
import LegalLinks from '@/components/LegalLinks';

const OnboardingView = ({ onComplete }) => {
  return (
    <div className="min-h-screen bg-primary flex items-center justify-center px-6 py-12" data-testid="onboarding-view">
      <div className="max-w-2xl w-full">
        <div className="space-y-8 fade-in custom-scroll" style={{ maxHeight: 'calc(100vh - 160px)', overflowY: 'auto' }}>
          {/* Header */}
          <div className="text-center space-y-3">
            <div className="flex justify-center mb-4">
              <div className="avatar-orb breathing" />
            </div>
            <h1 className="font-serif text-4xl md:text-5xl text-primary">
              Welcome to Eunoia Presence
            </h1>
          </div>

          {/* Opening */}
          <div className="space-y-4 text-center">
            <p className="text-lg text-primary leading-relaxed">
              Thank you for being here.
            </p>
            <p className="text-lg text-primary leading-relaxed">
              And just as importantly—<span className="font-medium">thank yourself.</span>
            </p>
            <div className="space-y-2 text-base text-secondary">
              <p>For pausing.</p>
              <p>For choosing presence, even for a moment.</p>
            </div>
            <p className="text-base text-primary font-medium pt-2">
              That choice matters.
            </p>
          </div>

          <div className="h-px bg-border my-8" />

          {/* What this space is for */}
          <div className="space-y-4">
            <h2 className="font-serif text-2xl text-primary">
              What this space is for
            </h2>
            <div className="space-y-4 text-base text-secondary leading-relaxed">
              <p>
                Eunoia is a quiet place to slow down and listen inwardly.
              </p>
              <p>
                It's not here to fix you, optimize you, or rush you forward.
              </p>
              <p>
                It's here to reflect, to soften, and to help you notice what's already within you.
              </p>
            </div>
            <div className="space-y-2 text-base text-primary pt-4">
              <p>You don't need the right words.</p>
              <p>You don't need a goal.</p>
              <p>You don't need to be anywhere else.</p>
            </div>
          </div>

          <div className="h-px bg-border my-8" />

          {/* How to use */}
          <div className="space-y-4">
            <h2 className="font-serif text-2xl text-primary">
              How to use Eunoia
            </h2>
            <div className="space-y-3 text-base text-secondary leading-relaxed">
              <p>• Begin with whatever is present—thoughts, feelings, or even uncertainty</p>
              <p>• Use the voice if it feels supportive, or keep things text-only</p>
              <p>• Stay for a few moments or linger longer—both are enough</p>
              <p>• Ask for what you need: reflection, gentleness, or practical help</p>
            </div>
            <p className="text-base text-primary italic pt-4">
              There's no right way to do this.
            </p>
          </div>

          <div className="h-px bg-border my-8" />

          {/* Reminder */}
          <div className="space-y-4">
            <h2 className="font-serif text-2xl text-primary">
              A gentle reminder
            </h2>
            <div className="space-y-4 text-base text-secondary leading-relaxed">
              <p>
                Eunoia doesn't replace your life, your relationships, or professional care.
              </p>
              <p>
                It's a companion for reflection—meant to support your own wisdom, not replace it.
              </p>
              <p className="text-primary font-medium">
                Everything you discover here already belongs to you.
              </p>
            </div>
          </div>

          <div className="h-px bg-border my-8" />

          {/* Ready */}
          <div className="space-y-4 text-center pb-6">
            <h2 className="font-serif text-2xl text-primary">
              When you're ready
            </h2>
            <div className="space-y-2 text-base text-secondary">
              <p>There's nothing to prepare.</p>
              <p>Nothing to achieve.</p>
              <p className="text-primary">Just begin where you are.</p>
            </div>
          </div>
        </div>

        {/* Begin Button - Fixed at bottom */}
        <div className="flex justify-center pt-8">
          <button
            onClick={onComplete}
            className="btn-primary text-lg px-16 py-4"
            data-testid="begin-btn"
          >
            Begin
          </button>
        </div>

        <LegalLinks style={{ marginTop: '24px' }} />
      </div>
    </div>
  );
};

export default OnboardingView;
